import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Mars = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Mars